import * as actions from "store/actions/invoice";
import IInvoice from "../../../Types/Invoice";

export interface InvoiceState {
	items: IInvoice[];
	invoicing: IInvoice[];
	filter: any[];
	pages: any;
	count: number;
	loading: any;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: InvoiceState = {
	items: [],
	invoicing: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false, getInvoicing: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_INVOICES: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_INVOICES_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false }
			};
		}
		case actions.GET_INVOICES_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}
		case actions.GET_INVOICING: {
			return {
				...state,
				loading: { getInvoicing: true },
				errors: initialState.errors
			};
		}
		case actions.GET_INVOICING_SUCCESS: {
			return {
				...state,
				invoicing: payload || [],
				loading: { getInvoicing: false }
			};
		}
		case actions.GET_INVOICING_FAILED: {
			return {
				...state,
				loading: { getInvoicing: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
